import { ConfigContext } from "@/providers/AppConfigProvider"
import { useContext } from "react"

// ==============================|| HOOKS - CONFIG  ||============================== //

const useConfig = () => useContext(ConfigContext)

export default useConfig
